import viewRequest from "./requests/view-request";
import deleteRequest from "./requests/delete-request";
import addRequest from "./requests/add-request";

const sourceRepository = {
    view: viewRequest,
    delete: deleteRequest,
    add: addRequest,
};

export default sourceRepository;
